import Auth from '../services/Auth';

import { CRM_PERMISSION } from './pages/Helpers/CrmPermissions';
import {
    CASINO_DASHBOARD,
    CASINO_DEPOSIT_BONUSES,
    CASINO_DEPOSIT_BONUS_PAGES,
    CASINO_FREESPIN_CAMPAIGNS,
    CASINO_FREESPIN_PAGES,
    CASINO_GAME_CATEGORY,
    CASINO_GAME_CATEGORY_BLOCKS,
    CASINO_GAME_CREATORS,
    CASINO_GAME_CREATOR_GGR_REPORT,
    CASINO_GAME_GGR_REPORT,
    CASINO_SETTINGS,
    CASINO_SLIDERS,
    CASINO_TOURNAMENTS,
    CASINO_TRANSACTIONS,
    CASINO_NEWS_GAMES_WIDGET,
} from './pages/Helpers/CrmUrls';

import LoggedAdmin from 'Api/Models/LoggedAdmin';
import {
    SidebarCategoryDropdownItem,
    SidebarCategoryItem,
    createSidebarCategoryDropdownItem,
    createSidebarCategoryItem,
} from 'crm/elements/Sidebar/SidebarCategoryTypes';

export function getDashboard(user: LoggedAdmin): SidebarCategoryItem {
    return Auth.userCan(user, CRM_PERMISSION.CASINO_DASHBOARD_INDEX)
        ? createSidebarCategoryItem('Casino dashboard', 'mdi-view-dashboard', CASINO_DASHBOARD)
        : null;
}

export function getReports(user: LoggedAdmin): SidebarCategoryItem[] {
    const items: SidebarCategoryItem[] = [];

    if (Auth.userCan(user, CRM_PERMISSION.CASINO_TRANSACTIONS_VIEW)) {
        items.push(createSidebarCategoryItem('Bets', 'mdi-autorenew', CASINO_TRANSACTIONS));
    }

    if (Auth.userCan(user, CRM_PERMISSION.REPORTS_GGR_INDEX)) {
        items.push(createSidebarCategoryItem('GGR per game', 'mdi-chart-bar', CASINO_GAME_GGR_REPORT));
        items.push(createSidebarCategoryItem('GGR per game creator', 'mdi-chart-bar', CASINO_GAME_CREATOR_GGR_REPORT));
    }

    return items;
}

export function getContent(user: LoggedAdmin): (SidebarCategoryItem | SidebarCategoryDropdownItem)[] {
    const items: (SidebarCategoryItem | SidebarCategoryDropdownItem)[] = [];
    if (Auth.userCan(user, CRM_PERMISSION.GAME_CATEGORIES_INDEX)) {
        items.push(createSidebarCategoryItem('Game categories', 'mdi-table-edit', CASINO_GAME_CATEGORY));
    }

    if (Auth.userCan(user, CRM_PERMISSION.GAME_CATEGORY_BLOCKS_INDEX)) {
        items.push(createSidebarCategoryItem('Game category block', 'mdi-table-edit', CASINO_GAME_CATEGORY_BLOCKS));
    }

    if (Auth.userCan(user, CRM_PERMISSION.TOURNAMENT_INDEX)) {
        items.push(createSidebarCategoryItem('Tournaments', 'mdi-trophy', CASINO_TOURNAMENTS));
    }

    if (Auth.userCan(user, CRM_PERMISSION.CASINO_SETTINGS_INDEX)) {
        items.push(createSidebarCategoryItem('Settings', 'mdi-settings', CASINO_SETTINGS));
    }

    if (Auth.userCan(user, CRM_PERMISSION.GAME_CREATORS_INDEX)) {
        items.push(createSidebarCategoryItem('Game creators', 'mdi-gamepad-variant', CASINO_GAME_CREATORS));
    }

    if (Auth.userCan(user, CRM_PERMISSION.CASINO_SLIDERS_VIEW)) {
        items.push(createSidebarCategoryItem('Casino Sliders', 'mdi-replay', CASINO_SLIDERS));
    }

    if (Auth.userCan(user, CRM_PERMISSION.NEWS_GAMES_WIDGET_INDEX)) {
        items.push(createSidebarCategoryItem('News games widget', 'mdi-newspaper', CASINO_NEWS_GAMES_WIDGET));
    }

    const bonusesDropdownItems: SidebarCategoryItem[] = getBonusesDropdownItems(user);
    if (bonusesDropdownItems.length > 0) {
        items.push(createSidebarCategoryDropdownItem('Bonuses', 'mdi-ticket-percent', bonusesDropdownItems));
    }

    const bonusPagesDropdownItems: SidebarCategoryItem[] = getBonusPagesDropdownItems(user);
    if (bonusPagesDropdownItems.length > 0) {
        items.push(createSidebarCategoryDropdownItem('Bonus pages', 'mdi-file', bonusPagesDropdownItems));
    }

    return items;
}

function getBonusesDropdownItems(user: LoggedAdmin): SidebarCategoryItem[] {
    const items: SidebarCategoryItem[] = [];
    if (Auth.userCan(user, CRM_PERMISSION.CASINO_FREESPIN_CAMPAIGNS_INDEX)) {
        items.push({
            name: 'Freespin campaigns',
            icon: 'mdi-view-module',
            path: CASINO_FREESPIN_CAMPAIGNS,
        });
    }

    if (Auth.userCan(user, CRM_PERMISSION.DEPOSIT_BONUS_INDEX)) {
        items.push({
            name: 'Deposit bonuses',
            icon: 'mdi-view-module',
            path: CASINO_DEPOSIT_BONUSES,
        });
    }

    return items;
}

function getBonusPagesDropdownItems(user: LoggedAdmin): SidebarCategoryItem[] {
    const items: SidebarCategoryItem[] = [];

    if (Auth.userCan(user, CRM_PERMISSION.FREESPIN_PAGE_INDEX)) {
        items.push({
            name: 'Freespin pages',
            icon: 'mdi-view-module',
            path: CASINO_FREESPIN_PAGES,
        });
    }

    if (Auth.userCan(user, CRM_PERMISSION.INDEX_DEPOSIT_BONUS_PAGE)) {
        items.push({
            name: 'Deposit bonus pages',
            icon: 'mdi-view-module',
            path: CASINO_DEPOSIT_BONUS_PAGES,
        });
    }

    return items;
}
